import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest, queryStringify } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const GetReverseProposalGoodsRequestSchema = z
  .object({
    keyword: z.string().optional(),
    brandId: z.string().optional(),
    page: z.number().min(1).optional(),
    size: z.number().min(1).max(100).optional(),
  })
  .describe('GetReverseProposalGoodsRequestSchema');

export type GetReverseProposalGoodsRequest = z.infer<typeof GetReverseProposalGoodsRequestSchema>;

const ReverseProposalGoodsItemSchema = z
  .object({
    goodsNo: z.number(),
    imageUrl: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    isLiked: z.boolean(),
  })
  .describe('ReverseProposalGoodsItemSchema');

const GetReverseProposalGoodsResponseDataSchema = z.object({
  list: z.array(ReverseProposalGoodsItemSchema),
});

const GetReverseProposalGoodsResponseSchema = createApiResponseSchema(
  GetReverseProposalGoodsResponseDataSchema,
);

export type GetReverseProposalGoodsResponse = z.infer<typeof GetReverseProposalGoodsResponseSchema>;

export const getReverseProposalGoods = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetReverseProposalGoodsRequestSchema),
    async (params: GetReverseProposalGoodsRequest): Promise<GetReverseProposalGoodsResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetReverseProposalGoodsResponse>(
          urlJoin(campaignsApiPath.getReverseProposalGoods),
          params,
          {
            paramsSerializer: (params) => queryStringify(params, { arrayFormat: 'comma' }),
          },
        );
        return response;
      }),
    validateApiResponse(GetReverseProposalGoodsResponseSchema),
  ),
);
